export enum EAreasTagType {
  AREAS = 'areas',
}
